import utils from "../utils";
import env from '../env';

export const isMobile = () => {
  var width = utils.css.screenWidth()
  return width < 768
}

export function resourcePath(url) {
  return utils.url.isExternalLink(url) ? url : env.resourceBase + url;
}

export function fullUrl(url) {
  return utils.url.isExternalLink(url) ? url : env.baseOrigin + url;
}

export function getAlternates(path) {
  const alternates = [];

  alternates.push({ hreflang: "en-au", href: "https://www.vssassoon.com.au" + path })
  alternates.push({ hreflang: "en-nz", href: "https://www.vssassoon.co.nz" + path })
  alternates.push({ hreflang: "x-default", href: "https://www.vssassoon.com.au" + path })

  return alternates;
}

export function callMCPoopu() {
  if (isNZ) return; // AU Mailchimp popup only
  const existingScript = document.getElementById('mcjs');
  if (!existingScript) {
    const script = document.createElement('script');
    script.type = `text/javascript`;
    script.text = `!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/6c684a43947babf266fc13d82/719754c1d34fe6e8c82c8784b.js");`;
    script.id = 'mcjs';
    document.head.appendChild(script);
  }
}

export function hideMCPopup() {
  const scriptSrc = '//downloads.mailchimp.com/js/signup-forms/popup/unique-methods/38d3020ee67bdafdc3231e2272e1fa0689108cda/popup.js';
  const scriptTag = document.querySelector(`script[src='${scriptSrc}']`);
  const floatingPopup = document.getElementById('mcforms-85750-106393');

  // If the script tag exists, remove it
  if (scriptTag) {
    scriptTag.remove();
    console.log('Script removed:', scriptSrc);
  }

  if (floatingPopup) {
    floatingPopup.style.display = 'none';
  }
} 

export const isNZ = env.locale === 'nz'